import types from '../types'

const SIZE_PER_PAGE = 25

const initialState = {
  claims: {
    loading: true,
    error: false,
    success: false,
    data: [],
    pagination: {
      sizePerPage: SIZE_PER_PAGE,
      totalSize: 0
    }
  },
  csvClaims: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  orgClaims: {
    loading: true,
    error: false,
    success: false,
    data: [],
    pagination: {
      sizePerPage: SIZE_PER_PAGE,
      totalSize: 0
    }
  },
  csvOrgClaims: {
    loading: false,
    error: false,
    success: false,
    data: []
  }
}

const claimsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CLAIMS_REQUESTED: {
      if ( action.claimType === 'CSV' ) {
        return {
          ...state,
          csvClaims: {
            loading: true,
            error: false,
            success: false,
            data: []
          }
        }
      } else {
        return {
          ...state,
          claims: {
            loading: true,
            error: false,
            success: false,
            data: [],
            pagination: {
              sizePerPage: SIZE_PER_PAGE,
              totalSize: 0
            }
          }
        }
      }
    }
    case types.GET_CLAIMS_FULFILLED: {
      if ( action.claimType === 'CSV' ) {
        return {
          ...state,
          csvClaims: {
            ...state.csvClaims,
            loading: false,
            success: true,
            data: action.payload
          }
        }
      } else {
        return {
          ...state,
          claims: {
            ...state.claims,
            loading: false,
            success: true,
            data: action.payload.results,
            pagination: {
              sizePerPage: SIZE_PER_PAGE,
              totalSize: action.payload.total
            }
          }
        }
      }
    }
    case types.GET_CLAIMS_REJECTED: {
      if ( action.claimType === 'CSV' ) {
        return {
          ...state,
          csvClaims: {
            ...state.csvClaims,
            loading: false,
            error: action.payload
          }
        }
      } else  {
        return {
          ...state,
          claims: {
            ...state.claims,
            loading: false,
            error: action.payload,
            pagination: {
              sizePerPage: SIZE_PER_PAGE,
              totalSize: 0
            }
          }
        }
      }
    }
    case types.GET_ORG_CLAIMS_REQUESTED: {
      if ( action.claimType === 'CSV' ) {
        return {
          ...state,
          csvOrgClaims: {
            loading: true,
            error: false,
            success: false,
            data: []
          }
        }
      } else {
        return {
          ...state,
          orgClaims: {
            loading: true,
            error: false,
            success: false,
            data: [],
            pagination: {
              sizePerPage: SIZE_PER_PAGE,
              totalSize: 0
            }
          }
        }
      }
    }
    case types.GET_ORG_CLAIMS_FULFILLED: {
      if ( action.claimType === 'CSV' ) {
        return {
          ...state,
          csvOrgClaims: {
            ...state.csvOrgClaims,
            loading: false,
            success: true,
            data: action.payload
          }
        }
      } else {
        return {
          ...state,
          orgClaims: {
            ...state.orgClaims,
            loading: false,
            success: true,
            data: action.payload.results,
            pagination: {
              sizePerPage: SIZE_PER_PAGE,
              totalSize: action.payload.total
            }
          }
        }
      }
    }
    case types.GET_ORG_CLAIMS_REJECTED: {
      if ( action.claimType === 'CSV' ) {
        return {
          ...state,
          csvOrgClaims: {
            ...state.csvOrgClaims,
            loading: false,
            error: action.payload
          }
        }
      } else {
        return {
          ...state,
          orgClaims: {
            ...state.orgClaims,
            loading: false,
            error: action.payload,
            pagination: {
              sizePerPage: SIZE_PER_PAGE,
              totalSize: 0
            }
          }
        }
      }
    }
    case types.CLEAR_CSV_CLAIMS: {
      if ( action.csvType === 'ORG' ) {
        return {
          ...state,
          csvOrgClaims: {
            loading: false,
            error: false,
            success: false,
            data: []
          }
        }
      } else {
        return {
          ...state,
          csvClaims: {
            loading: false,
            error: false,
            success: false,
            data: []
          }
        }
      }
    }
    default:
      return state
  }
}

export default claimsReducer